import PropTypes from 'prop-types';
import {css} from 'styled-components';
import {map} from 'styled-components-breakpoint';
import {ResponsiveOrStaticProp, Nullable} from './../../utils';

const validDisplayValues = ['none', 'inline', 'block', 'inline-block', 'flex', 'inline-flex'] as const;
export type displayValues = typeof validDisplayValues[number];

export type DisplayType = ResponsiveOrStaticProp<Nullable<displayValues>>;

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types
export const display = (props: any) => css`
  ${({display}: {display: DisplayType}) =>
    map(
      display,
      (val: displayValues) =>
        val &&
        css`
          display: ${val};
        `
    )};
`;

export const displayPropType = PropTypes.oneOf(validDisplayValues);

export const displayPropTypeMap = PropTypes.oneOfType([
  displayPropType,
  PropTypes.shape({
    xs: displayPropType,
    sm: displayPropType,
    md: displayPropType,
    lg: displayPropType,
    xl: displayPropType,
    xxl: displayPropType,
    xxxl: displayPropType
  })
]);
